import { ImageLibraryItem } from "@/shared/imageLibrary/types";

export const normalizeText = (value: string) =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

const toWords = (value: string) =>
  normalizeText(value)
    .split(/[^a-z0-9]+/)
    .filter((word) => word.length >= 3);

/** Name is a slug like "sushi--hero", so the description is searched too. */
export const matchesLibrarySearch = (item: ImageLibraryItem, search: string) => {
  const query = normalizeText(search.trim());
  if (!query) return true;
  const haystack = normalizeText(`${item.name} ${item.description ?? ""}`);
  return query.split(/\s+/).every((word) => haystack.includes(word));
};

/**
 * Library item names that match a word of the text (e.g. a product name),
 * e.g. "Pizza's Hawaï" → pizza, "Cheeseburgers" → burger. Only words from the
 * item names are suggested, so every suggestion has results.
 */
export const suggestSearches = (text: string, items: ImageLibraryItem[]) => {
  const words = toWords(text);
  const nameWords = new Set(items.flatMap((item) => toWords(item.name)));
  return [...nameWords].filter((name) =>
    words.some(
      (word) =>
        word === name ||
        (name.length >= 4 && word.includes(name)) ||
        (word.length >= 4 && name.startsWith(word))
    )
  );
};
